import React from 'react';
import InformationalModalBase from '@Generic/modals/InformationalModal/InformationalModalBase';

export const SuccessModal = (props) => <InformationalModalBase variant='success' {...props} />;
export const InfoModal = (props) => <InformationalModalBase variant='info' {...props} />;
export const AdvisoryModal = (props) => <InformationalModalBase variant='advisory' {...props} />;
export const WarningModal = (props) => <InformationalModalBase variant='warning' {...props} />;
